// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import "./EntranceForms.css";
import * as apiCall from "./../../api/apiCall";

const EntranceForms = ({
  setFormSubmit,
  postUser,
  config,
  setGain,
  setWin,
  setEmail,
}) => {
  const [formData, setFormData] = useState({
    code: "",
    lastname: "",
    firstname: "",
    address: "",
    phone: "",
    email: "",
    birthDate: "",
    postalCode: "",
    optin: false,
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [optin, setOptin] = useState(false);

  async function getGains(idConfig) {
    try {
      let data = await apiCall.getGains(idConfig);
      console.log("gains data", data);
      setGain(data);
      if (data && Object.keys(data).length > 0) {
        setWin(true);
      }
      return data;
    } catch (error) {
      console.error("Error fetching gains:", error);
    }
  }

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };
  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;

    // Si le champ est une checkbox, on met à jour l'état avec la valeur `checked` (true/false)
    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked, // Utilisation de `checked` pour les checkboxes
      });
    } else {
      // Pour les champs texte (input de type text, email, etc.), on continue de mettre à jour avec `value`
      setFormData({
        ...formData,
        [name]: value, // Utilisation de `value` pour les autres champs
      });
    }
  };

  const handleBirthDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Supprimer tout caractère non numérique
    if (value.length > 2) {
      value = value.slice(0, 2) + "-" + value.slice(2);
    }
    if (value.length > 5) {
      value = value.slice(0, 5) + "-" + value.slice(5, 10);
    }
    setFormData({
      ...formData,
      birthDate: value,
    });
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData({
        ...formData,
        phone: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      //const codeCheckin = await checkCode(config.id, formData.code);
      const gains = await getGains(config.id);
      await postUser(
        formData.firstname,
        formData.lastname,
        formData.address,
        formData.phone,
        formData.email,
        formData.birthDate,
        formData.postalCode,
        "gencode",
        formData.optin,
        gains.id,
        config.id
      );
      setEmail(formData.email);

      setFormSubmit(true);
      setLoading(false);
      setErrorMessage(""); // Effacer le message d'erreur en cas de succès
    } catch (error) {
      console.error(
        "Une erreur s'est produite lors de la validation du code",
        error
      );
    }
  };
  return (
    <div
      className="forms"
      style={{ backgroundColor: config ? config.secondaryColor : "#000" }}
    >
      <div className="explanationText">
        <div className="header">Bienvenue !</div>
      </div>
      <form onSubmit={handleSubmit}>
        {errorMessage && <div style={{ color: "black" }}>{errorMessage}</div>}
        <div className="content">
          Pour particper au jeu, merci de remplir tous les champs ci-dessous :
        </div>
        {config.lastname && (
          <div>
            <input
              type="text"
              id="lastname"
              name="lastname"
              value={formData.lastname}
              placeholder="Nom"
              onChange={handleChange}
              required
            />
          </div>
        )}
        {config.firstname && (
          <div>
            <input
              type="text"
              id="firstname"
              name="firstname"
              placeholder="Prénom"
              value={formData.firstname}
              onChange={handleChange}
              required
            />
          </div>
        )}

        {config.phone && (
          <div>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Téléphone"
              value={formData.phone}
              onChange={handlePhoneChange}
              required
              inputMode="numeric"
            />
          </div>
        )}
        {config.email && (
          <div>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        )}
        {config.birthDate && (
          <div>
            <input
              type="text"
              id="birthDate"
              name="birthDate"
              placeholder="Date de naissance (JJ-MM-AAA)"
              value={formData.birthDate}
              onChange={handleBirthDateChange}
              inputMode="numeric"
              pattern="\d{2}-\d{2}-\d{4}"
              required
            />
          </div>
        )}

        {config.postalCode && (
          <div>
            <input
              type="tel"
              id="postalCode"
              name="postalCode"
              placeholder="Code Postal"
              value={formData.postalCode}
              onChange={handleChange}
              required
            />
          </div>
        )}
        {config.address && (
          <div>
            <input
              type="text"
              id="address"
              name="address"
              placeholder="Ville"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>
        )}
        <div className="checkboxContainer">
          <label>
            <input
              type="checkbox"
              id="optin"
              name="optin"
              checked={formData.optin}
              onChange={handleChange}
            />
            {config
              ? config.optinText
              : "J'accepte de recevoir les offres et les actualités"}
          </label>
        </div>
        <div className="submitButton">
          <button
            type="submit"
            style={{
              backgroundColor: config ? config.primaryColor : "#000",
              color: config ? config.secondaryColor : "#000",
            }}
          >
            {loading ? "Envoi en cours.." : "Envoyer pour jouer"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EntranceForms;
